const FooterToggle = () => {

    // Slide down submenus (on open)
    const slideDown = element => element.style.height = `${element.scrollHeight}px`;

    // Slide up submenus (on close)
    const slideUp = element => element.style.height = '0px';

    // Fetch all links with data-footer-toggle attached
    let toggles = document.querySelectorAll('[data-footer-toggle]');

    Array.from(toggles).forEach(toggle => {

        // Fetch the reference in the data attribute
        let target_attr = toggle.getAttribute('data-footer-toggle');
        // Use the reference to fetch the matching element to toggle open/closed
        let target_element = document.querySelector(`[data-footer-item="${target_attr}"]`);
        
        // If the element is defined/exists, proceed
        if (typeof target_element != "undefined" && target_element != null) {

            // When the link is clicked
            toggle.addEventListener('click', () => {

                // If the toggle div already has the active class
                if (toggle.matches('.top-footer__wrap--active')) {
                    // Remove the active class
                    toggle.classList.remove('top-footer__wrap--active');
                    // Close the proceeding element
                    slideUp(target_element);
                } else {
                    // Add the active class
                    toggle.classList.add('top-footer__wrap--active');
                    // Open the proceeding element
                    slideDown(target_element);
                }
            });
        }
    });
}

export default FooterToggle;